import {useCallback} from 'react';

import NiceModal, {useModal} from '@ebay/nice-modal-react';

import {useI18n} from '@yourcoach/i18n';

import type {ConferenceType} from '../../types';

import {Modal} from '../../../../components/Modal';
import {ConferenceTypePicker} from '../../../conference/components/ConferenceTypePicker';

type Props = {
  duration: number;
};

export const BookConferenceTypePicker = NiceModal.create<Props>(
  ({duration}) => {
    const {t} = useI18n();
    const modal = useModal();

    const onRequestClose = useCallback(() => {
      modal.resolve();
      modal.hide();
    }, [modal]);

    const onTypePick = useCallback(
      (type: ConferenceType) => {
        modal.resolve(type);
        modal.hide();
      },
      [modal],
    );

    return (
      <Modal
        isOpen={modal.visible}
        maxWidth="500px"
        onAfterClose={modal.remove}
        onRequestClose={onRequestClose}
        title={t('shared:schedule_session.live')}
      >
        <ConferenceTypePicker duration={duration} onTypeClick={onTypePick} />
      </Modal>
    );
  },
);
